import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

export const loginAgent = createAsyncThunk("auth/login", async (credentials) => {
  const response = await api.post("/auth/login", credentials);
  localStorage.setItem("qq_token", response.data.token);
  localStorage.setItem("qq_agent", JSON.stringify(response.data.agent));
  return response.data;
});

export const registerAgent = createAsyncThunk("auth/register", async (data) => {
  const response = await api.post("/auth/register", data);
  localStorage.setItem("qq_token", response.data.token);
  localStorage.setItem("qq_agent", JSON.stringify(response.data.agent));
  return response.data;
});

export const updateProfile = createAsyncThunk("auth/updateProfile", async (data) => {
  const response = await api.patch("/agents/profile", data);
  localStorage.setItem("qq_agent", JSON.stringify(response.data.agent));
  return response.data;
});

const savedAgent = localStorage.getItem("qq_agent");
const savedToken = localStorage.getItem("qq_token");

const authSlice = createSlice({
  name: "auth",
  initialState: {
    agent: savedAgent ? JSON.parse(savedAgent) : null,
    token: savedToken || null,
    status: "idle",
    error: null,
  },
  reducers: {
    logout(state) {
      state.agent = null;
      state.token = null;
      localStorage.removeItem("qq_token");
      localStorage.removeItem("qq_agent");
    },
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginAgent.pending, (state) => { state.status = "loading"; state.error = null; })
      .addCase(loginAgent.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.agent = action.payload.agent;
        state.token = action.payload.token;
      })
      .addCase(loginAgent.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(registerAgent.pending, (state) => { state.status = "loading"; state.error = null; })
      .addCase(registerAgent.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.agent = action.payload.agent;
        state.token = action.payload.token;
      })
      .addCase(registerAgent.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.agent = action.payload.agent;
      });
  },
});

export const { logout, clearError } = authSlice.actions;
export default authSlice.reducer;
